import { z } from "zod";
import { ErrorIdSchema, IsoDateTimeSchema } from "./common.js";

/** Hermes Adapter 内部状态。普通 UI 应映射为产品语言，而不是直接显示这些 code。 */
export const AdapterConnectionStateSchema = z.enum([
  "idle",
  "connecting",
  "authenticating",
  "waiting_gateway",
  "probing",
  "hydrating",
  "ready",
  "degraded",
  "reconnecting",
  "incompatible",
  "offline",
]);

export const ConnectionLayerSchema = z.enum(["browser_to_herskin", "herskin_to_hermes", "session"]);

export const ConnectionLayerStatusSchema = z.enum([
  "online",
  "connecting",
  "recovering",
  "degraded",
  "offline",
  "incompatible",
  "unknown",
]);

export const ConnectionLayerStateSchema = z
  .object({
    layer: ConnectionLayerSchema,
    status: ConnectionLayerStatusSchema,
    updatedAt: IsoDateTimeSchema,
    lastConnectedAt: IsoDateTimeSchema.nullable(),
    errorId: ErrorIdSchema.optional(),
  })
  .strict();

export const ConnectionSnapshotSchema = z
  .object({
    adapterState: AdapterConnectionStateSchema,
    overall: ConnectionLayerStatusSchema,
    layers: z.array(ConnectionLayerStateSchema).min(2).max(3),
    updatedAt: IsoDateTimeSchema,
  })
  .strict();

/** M3 客户端使用的连接状态响应；保留 Snapshot 旧名便于表达其事实快照语义。 */
export const ConnectionStateSchema = ConnectionSnapshotSchema;

export type AdapterConnectionState = z.infer<typeof AdapterConnectionStateSchema>;
export type ConnectionLayerState = z.infer<typeof ConnectionLayerStateSchema>;
export type ConnectionSnapshot = z.infer<typeof ConnectionSnapshotSchema>;
export type ConnectionState = z.infer<typeof ConnectionStateSchema>;
